import { configureStore } from '@reduxjs/toolkit'
import providerReducer from './features/providerSlice'
import modalReducer from './features/modalSlice'

export default configureStore({
  reducer: {
    provider: providerReducer,
    modal: modalReducer
  }
})
